import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';
import isString from 'lodash-es/isString';

import { groupTypes } from '../../lib/maps';

import PinIcon from './maps/Pin';
import * as iconComponents from './maps/index';

import styles from '../../styles/icons/map-marker.module.css';

interface MapMarkerProps {
    theme?: string | null;
    icons?: string | string[];
    className?: string | null;
    pinClassName?: string | null;
    iconClassName?: string | null;
}

function MapMarker({
    theme = null,
    icons = null,
    className = null,
    iconClassName = null,
    pinClassName = null,
}: MapMarkerProps) {
    const finalIcons = (isString(icons) ? [icons] : icons) || [];
    return (
        <div className={classNames([styles.container, styles[theme], className])}>
            <PinIcon
                className={classNames([styles.pin, pinClassName])}
                border={theme === 'winter' ? '#fff0e0' : '#222'}
                theme={theme as string}
            />
            <div
                className={classNames([
                    styles.icons,
                    {
                        [styles.many]: finalIcons.length > 1,
                        [styles.two]: finalIcons.length === 2,
                        [styles.three]: finalIcons.length === 3,
                    },
                ])}
            >
                {finalIcons.map((icon, i) => {
                    const groupType = groupTypes.find(
                        ({ types: subTypes = null }) =>
                            subTypes === null || subTypes.indexOf(icon) !== -1,
                    );
                    const IconComponent =
                        getComponentFromName(iconComponents, icon) ||
                        getComponentFromName(
                            iconComponents,
                            groupType !== null ? groupType.slug : icon,
                        );
                    const iconCamelCase = camelCase(icon);
                    return IconComponent !== null ? (
                        <IconComponent
                            key={`icon-${i + 1}`}
                            className={classNames([
                                styles.icon,
                                styles[iconCamelCase],
                                iconClassName,
                            ])}
                        />
                    ) : null;
                })}
            </div>
        </div>
    );
}

export default MapMarker;
